import Vue from 'vue';
import { apiPath } from '@/api/constants';

const AppBundle = Vue.resource(
  `${apiPath}/apps{/packageName}/bundle{/id}{/action}/`,
  {},
  {
    getBundle: {
      method: 'GET',
      params: { action: 'status' },
      showProgressBar: false,
    },
    getSignInfo: { method: 'GET', params: { action: 'sign' } },
    sendSign: { method: 'POST', params: { action: 'sign' } },
  },
);

export default AppBundle;
